import type {FormSchemaProperty} from '../../../../../ui/core/nutshell-fields/types';

export function getFilteredCustomFields(schemaFields: FormSchemaProperty[]): FormSchemaProperty[] {
    return schemaFields.filter(
        (field) =>
            field.entityType !== 'Leads' &&
            field.isCustomField &&
            field.type !== 'enum-multiple' &&
            Boolean(field.mergeTagName)
    );
}

export function getFieldKey(field: FormSchemaProperty): string {
    return `${field.name}-${field.entityType}`;
}
